module.exports = __webpack_public_path__ + "static/media/intro-bg-wide.e5cd856a.png";